export default __webpack_public_path__ + "static/media/menu_dashboard_selected.5a284ad1.svg";